import { Stack, Tabs } from '@mantine/core'
import { useQueryParamTab } from 'src/utils/tabQueryParam'
import NetworkPage from './NetworkPage'
import ConversationPage from 'src/pages/ConversationPage/ConversationPage'
import CommunityLocationStatsPage from 'src/containers/Network/CommunityLocationStatsPage'

function NetworkTabsPage() {
	const tabValues = ['communities', 'category', 'vietnam', 'other-countries'] as const
	const { activeTab, handleTabChange } = useQueryParamTab(tabValues, 'communities')

	return (
		<Stack
			sx={{
				width: '100%',
			}}
		>
			<Tabs value={activeTab} onTabChange={handleTabChange} keepMounted={false}>
				<Tabs.List>
					<Tabs.Tab value="communities" fw={700}>
						Communities
					</Tabs.Tab>
					<Tabs.Tab value="category" fw={700}>
						Category
					</Tabs.Tab>
					<Tabs.Tab value="vietnam" fw={700}>
						Vietnam
					</Tabs.Tab>
					<Tabs.Tab value="other-countries" fw={700}>
						Other countries
					</Tabs.Tab>
				</Tabs.List>

				<Tabs.Panel value="communities" pt="md">
					<NetworkPage />
				</Tabs.Panel>

				<Tabs.Panel value="category" pt="md">
					<ConversationPage />
				</Tabs.Panel>

				<Tabs.Panel value="vietnam" pt="md">
					<CommunityLocationStatsPage scope="vietnam" />
				</Tabs.Panel>

				<Tabs.Panel value="other-countries" pt="md">
					<CommunityLocationStatsPage scope="other" />
				</Tabs.Panel>
			</Tabs>
		</Stack>
	)
}

export default NetworkTabsPage
